/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconRightRotate = (props) => (
  <SVG
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8605 31.4605C17.9273 31.4643 19.9745 31.0601 21.8846 30.2709C23.7948 29.4817 25.5304 28.3232 26.9918 26.8618C28.4532 25.4004 29.6117 23.6648 30.4009 21.7546C31.1901 19.8445 31.5943 17.7973 31.5905 15.7305H15.8605V0.000537221C13.7948 -0.0165346 11.746 0.373432 9.83103 1.14817C7.91605 1.9229 6.17241 3.06723 4.69967 4.51583C1.72535 7.44139 0.0350161 11.4287 0.000537913 15.6005C-0.0339402 19.7724 1.59026 23.7871 4.51582 26.7614C7.44139 29.7357 11.4287 31.4261 15.6005 31.4605H15.8605Z"
      fill="#CECECD"
    />
    <path
      d="M20.2805 24.1805C12.7405 26.9105 3.90054 19.6305 6.50054 11.7005"
      stroke="black"
    />
    <path
      d="M17.2908 21.5805L24.4408 21.3205L21.0608 27.5605L17.2908 21.5805Z"
      fill="black"
    />
    <path
      d="M9.23072 14.5605L9.10072 7.28052L2.99072 11.0505L9.23072 14.5605Z"
      fill="black"
    />
  </SVG>
)

export default withIconStyles(IconRightRotate)
